import { Flex, Text, useMantineTheme, Tooltip, Center } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { InfoCircle } from "iconsax-react";
import { formatCurrency } from "../../../../../utils/currency";

interface IProps {
  label: string;
  value: number;
  title: string;
}

export default function TextTooltipValue({ label, value, title }: IProps) {
  const theme = useMantineTheme();
  const formattedValue = formatCurrency(value);

  return (
    <Flex justify={"space-between"} w="100%" gap="16px" h="19px">
      <Flex gap="5px" align="center">
        <Text
          style={{
            color: theme.colors.basic[4],
            fontSize: "12px",
            fontWeight: 500,
          }}
        >
          {title}
        </Text>
        {/* <Tooltip label={label} withArrow maw={350} multiline>
          <Center>
            <InfoCircle size="14" color="#D7D7D7" variant="Bold" />
          </Center>
        </Tooltip> */}
      </Flex>

      <Text
        style={{
          color: theme.colors.basic[5],
          fontSize: "12px",
          fontWeight: 500,
        }}
      >
        {formattedValue}
      </Text>
    </Flex>
  );
}
